module.exports = __webpack_public_path__ + "static/img/oil3.14dee3ff.png";